import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FDFields,
  BondsFields,
  AssetPage,
  MutualFundsFields,
  CashFields,
  PreciousMetalsFields,
  RealEstateFields,
  InternationalEquityFields,
  PMSFields,
  DirectEquityFields
} from '../asset-selection/asset-catalog/types';

@Component({
  selector: 'app-asset-item',
  templateUrl: './asset-item.component.html',
  styleUrls: ['./asset-item.component.css']
})

export class AssetItemComponent implements OnInit {
  @Input() item;
  @Input() value;
  @Input() jsonValue;
  @Output() jsonValueChange = new EventEmitter();
  @Input() sipValue;
  @Output() valueChange = new EventEmitter();
  @Output() sipValueChange = new EventEmitter();
  @Output() change = new EventEmitter();
  @Output() sipChange = new EventEmitter();
  @Input() page;

  public pages = AssetPage;
  public FDFields = FDFields;
  public BondsFields = BondsFields;
  public MutualFundsFields = MutualFundsFields;
  public CashFields = CashFields;
  public PreciousMetalsFields = PreciousMetalsFields;
  public RealEstateFields = RealEstateFields;
  public InternationalEquityFields = InternationalEquityFields;
  public PMSFields = PMSFields;
  public DirectEquityFields = DirectEquityFields;

  constructor() {}

  ngOnInit() {}

  onChange(event) {
    console.log(event);
    this.valueChange.emit(event);
    this.change.emit(event);
  }

  onSIPChange(event) {
    console.log(event);
    this.sipValueChange.emit(event);
    this.sipChange.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/asset-item/asset-item.component.ts